import { Component, OnInit, ViewChild } from '@angular/core';
import { Listing } from 'src/app/shared/models/listing.model';
import { GridViewComponent } from 'src/app/shared/components/grid-view/grid-view.component';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { LongHaulService } from 'src/app/shared/services/long-haul.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { User } from 'src/app/front-user/shared/models/user.model';
import { EtenderService } from 'src/app/shared/services/etender.service';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { ETenderAdminTypes } from 'src/app/shared/models/e-tender.model';

@Component({
  selector: 'app-rebate-requests-management',
  templateUrl: './rebate-requests-management.component.html'
})

export class RebateRequestsManagementComponent implements OnInit {
  private isLHManagement : boolean = false;
  //#region Properties & Variables
  private collection: Listing;
  private pageIndex: number = 0;
  private pageSize: number = 15;
  userGroups: number[] = [];
  private sortBy: string = "ModifiedDate";
  private sortDirection: string = "DESC";
  private itemsMenu: MenuItem[] = [];
  @ViewChild('LongHaulRequests',{static: false}) gridView: GridViewComponent;
  private getActiveRequestsResponseObject: ResponseObject = new ResponseObject();
  //User Properties
  public currentUser: User = new User();
  //Search
  private searchTerm: string = "";
  public isRequestFailed: boolean = false;
  //#endregion

  constructor( private etenderSrv: EtenderService, private global: GlobalServices,private globalServices: GlobalServices, private longHaulService: LongHaulService, private route: Router, private authenticationService: AuthenticationService) {
    //this.currentUser = this.globalServices.user;
    this.currentUser = this.authenticationService.currentUserValue;
    this.etenderSrv.GetUserGroups(this.currentUser.Email).subscribe(
      data => {
        this.userGroups = data.Data;
        if(this.userGroups != null)
        {
          if (this.userGroups.filter(ug => ug == ETenderAdminTypes.SCAServices_MeasurementCommittee ||
            ug == ETenderAdminTypes.SCAServices_EconomicCommittee ||
            ug == ETenderAdminTypes.SCAServices_LHManagementandReportsOnly ||
            ug == ETenderAdminTypes.SCAServices_LongHaulFormulatedDecision).length > 0) {
            this.isLHManagement = true;
          }
        }
    if(!this.isLHManagement)
      this.route.navigateByUrl('/workspace');
    },
    () => console.log('Something went wrong!!')
  );
  }
  ngOnInit() {
    //Enable Loader
    this.globalServices.isLoaderEnabled = true;
    this.getActiveRequests();
  }
  getActiveRequests(): void {
    this.longHaulService.getActiveRequestsPagedSorted(this.pageIndex, this.pageSize, this.sortBy, this.sortDirection, this.searchTerm).subscribe(
      data => this.getActiveRequestsResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.getActiveRequestsCompleted()
    );
  }
  getActiveRequestsCompleted(): void {
    if(this.getActiveRequestsResponseObject.Success){
      this.loadItemsMenu();
      this.collection = this.getActiveRequestsResponseObject.Data as Listing;
      //Phase3
      let seviceEndPoint: string = "LongHaul/getActiveRequestsPagedSorted?pageIndex={PAGEINDEX}&pageSize=" + this.pageSize + "&sortBy=ModifiedDate&sortDirection=DESC" + "&searchTerm=" + this.searchTerm;
      this.gridView.loadGrid(this.collection, this.collection.TotalNumber, this.pageSize, seviceEndPoint, "FRONT_USER.LongHaulRequestsManagement", this.itemsMenu, this.sortBy, this.sortDirection, "LongHaulRequestsManagement");
      const el = document.getElementsByClassName('sectionTitle');
      if(el[0] != undefined)
        el[0].scrollIntoView({behavior:'smooth'});
    } else {
      //Enable Error
      this.isRequestFailed = true;
    }
    //Disable Loader
    this.globalServices.isLoaderEnabled = false;
  }
  loadItemsMenu(): void {
    this.itemsMenu[0] = new MenuItem();
    this.itemsMenu[0].Title = "Details";
    this.itemsMenu[1] = new MenuItem();
    this.itemsMenu[1].Title = "Request History";
  }
  loadLongHaulRequests(): void {
    this.getActiveRequests();
  }
  resetLongHaulRequests(): void {
    this.searchTerm = "";
    this.getActiveRequests();
  }
}

export class MenuItem {
  Title: string;
};
